import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCompaniesWithBrands } from "../api/endpoints";

// Async thunk to fetch companies with brands data
export const fetchCompaniesWithBrandsData = createAsyncThunk(
  "competitors/fetchCompaniesWithBrands",
  async ({ id_client, country }, { rejectWithValue }) => {
    try {
      console.log(`[competitors] Fetching companies tree for id_client=${id_client} country=${country}`);
      const response = await getCompaniesWithBrands({ id_client, country });
      console.log(`[competitors] Response for ${country}:`, response);
      console.log(`[competitors] Companies count for ${country}:`, response?.companies?.length ?? "N/A");
      return { country, data: response };
    } catch (error) {
      console.error("[competitorsSlice] Error fetching companies:", error);
      return rejectWithValue(error.message || "Failed to fetch companies");
    }
  }
);

const initialState = {
  companiesWithBrands: {}, // keyed by country code
  loadingByCountry: {}, // keyed by country code
  error: null,
};

const competitorsSlice = createSlice({
  name: "competitors",
  initialState,
  reducers: {
    clearCompetitors: (state) => {
      state.companiesWithBrands = {};
      state.loadingByCountry = {};
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompaniesWithBrandsData.pending, (state, action) => {
        const { country } = action.meta.arg;
        state.loadingByCountry[country] = true;
        state.error = null;
      })
      .addCase(fetchCompaniesWithBrandsData.fulfilled, (state, action) => {
        const { country, data } = action.payload;
        state.loadingByCountry[country] = false;
        state.companiesWithBrands[country] = data || null;
      })
      .addCase(fetchCompaniesWithBrandsData.rejected, (state, action) => {
        const { country } = action.meta.arg;
        state.loadingByCountry[country] = false;
        state.error = action.payload || "Failed to fetch companies";
      });
  },
});

export const { clearCompetitors } = competitorsSlice.actions;

export default competitorsSlice.reducer;

